import React from 'react';

export const ApiDataContext = React.createContext({});
